import { parse, stringify } from '../lib/query'
import { createBrowserHistory } from 'history'

const splitPath = path => {
  const idx = path.indexOf('?')
  if (idx === -1) return { pathname: path, search: '' }
  return { pathname: path.slice(0, idx), search: path.slice(idx) }
}

const createPreserveQueryBrowserHistory = options => {
  const history = createBrowserHistory(options)

  const oldPush = history.push
  const oldReplace = history.replace

  const buildParams = (path, state) => {
    const locationDescriptorObject = typeof path === 'string' ? { ...splitPath(path), ...state } : path
    // replaceQuery: this search exactly, nothing kept (a key taken out).
    if (locationDescriptorObject?.replaceQuery) {
      const { replaceQuery, ...rest } = locationDescriptorObject
      return rest
    }
    const currentQuery = parse(history.location.search)
    const newQuery = parse(locationDescriptorObject?.search)
    return {
      ...locationDescriptorObject,
      search: stringify({ ...currentQuery, ...newQuery })
    }
  }

  history.push = (path, state) => oldPush.apply(history, [buildParams(path, state)])
  history.replace = (path, state) => oldReplace.apply(history, [buildParams(path, state)])

  return history
}

export const browserHistory = createPreserveQueryBrowserHistory()
